<template>
	<div>
		<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
			<div class="layout-title-left">
				<img src="/static/imgs/wuliuche.png" class="jxyd-imgicon" />
				物流信息
			</div>
			<div class="layout-title-right">
			</div>
		</div>
		<Table stripe :columns="logisticsInfoColumn" :data="logisticsInfos"></Table>
		<Modal v-model="configModal" draggable sticky scrollable>
			<p slot="header" style="text-align:left">
				<Icon type="ios-create-outline" size='18' />
				<span> 添加选项</span>
			</p>
			<div style="width:100%;padding:5px;background-color:#fff;border-radius:5px;height:300px;overflow:auto;">
				<table style="width:100%;">
					<tr>
						<td style="width:100%;" colspan="2">
							<Input v-model="dictionaryFormItem.key" placeholder="请输入选项"
								@keyup.enter.native="addType()" />
						</td>
					</tr>
					<tr>
						<td class="tab-hander" style="width: 180px;">选项</td>
						<td class="tab-hander" style="text-align:center;">操作</td>
					</tr>
					<tr v-for="item in companyTypeList">
						<td>{{item.key}}</td>
						<td style="text-align:center;">
							<Icon type="md-trash" size='18' class="icon-item-dele" @click.stop="deleType(item.id)" />
						</td>
					</tr>
				</table>
			</div>
			<div slot="footer">
				<button class="jxyd-button jxyd-primary" @click="configModal = false;">关闭</button>
				<button class="jxyd-button" @click="addType()">保存</button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		name: 'extracostdata',
		props: ['selectedLogistics'],
		data() {
			return {
				logisticsInfos: [],
				companyTypeList: [],
				companyNamePid: 'wlgs',
				configModal: false,
				dictionaryFormItem: {
					id: 0,
					key: '',
					value: '',
					pid: 0,
					pcode: '',
					creator: parseInt(localStorage.getItem("userId"))
				},
				logisticsInfoColumn: [{
						title: '物流公司',
						key: 'companyName',
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.companyName
									},
									style: {
										width: '85%'
									},
									on: {
										input: (event) => {
											this.logisticsInfos[params.index].companyName =
												event;
											this.$emit('update:selectedLogistics', this
												.logisticsInfos);
										}
									},
								},
								this.companyTypeList.map(function(type) {
									return h('Option', {
										props: {
											value: type.key,
											key: type.key
										}
									}, type.key);
								})
							), h('Icon', {
								style: {
									cursor: 'pointer',
								},
								props: {
									type: "ios-settings-outline",
									size: 24
								},
								on: {
									click: (e) => {
										this.configModal = true;
									}
								}
							})];
						}
					},
					{
						title: '物流单号',
						key: 'code',
						render: (h, params) => {
							return [h('Input', {
								props: {
									min: 0,
									value: params.row.code
								},
								style: {
									'width': '100%'
								},
								on: {
									input: (e) => {
										this.logisticsInfos[params.index].code = e;
										this.$emit('update:selectedLogistics', this
											.logisticsInfos);
									}
								}
							})]
						}
					},
					{
						title: '收货人',
						key: 'receiver',
						render: (h, params) => {
							return [h('Input', {
								props: {
									min: 0,
									value: params.row.receiver
								},
								style: {
									'width': '100%'
								},
								on: {
									input: (e) => {
										this.logisticsInfos[params.index].telephone = e;
										if(e.length>11){
											this.$Notice.error({
												title: '错误提示',
												duration: 3,
												desc: "电话格式有误！"
											});
											this.logisticsInfos[params.index].telephone = '';
											return;
										}
										this.$emit('update:selectedLogistics', this
											.logisticsInfos);
									}
								}
							})]
						}
					},
					{
						title: '联系电话',
						key: 'telephone',
						render: (h, params) => {
							return [h('Input', {
								props: {
									min: 0,
									value: params.row.telephone
								},
								style: {
									'width': '100%'
								},
								on: {
									input: (e) => {
										this.logisticsInfos[params.index].telephone = e;
										this.$emit('update:selectedLogistics', this
											.logisticsInfos);
									}
								}
							})]
						}
					},
					{
						title: '运费',
						key: 'freight',
						render: (h, params) => {
							return [h('InputNumber', {
								props: {
									value: params.row.freight
								},
								style: {
									'width': '100%'
								},
								on: {
									input: (e) => {
										this.logisticsInfos[params.index].freight = e;
										this.$emit('update:selectedLogistics', this
											.logisticsInfos);
									}
								}
							})]
						}
					},
					{
						title: '说明',
						key: 'note',
						render: (h, params) => {
							return [h('Input', {
								props: {
									min: 0,
									value: params.row.note
								},
								style: {
									'width': '100%'
								},
								on: {
									input: (e) => {
										this.logisticsInfos[params.index].note = e;
										this.$emit('update:selectedLogistics', this
										.logisticsInfos);
									}
								}
							})]
						}
					},
					{
						title: '操作',
						key: 'action',
						align: 'center',
						render: (h, params) => {
							var btnArr = [];
							btnArr.push(h('Icon', {
								style: {
									cursor: 'pointer',
									'margin-right': '10px'
								},
								props: {
									type: 'md-add-circle',
									size: 24,
									color: '#ff6a7f'
								},
								on: {
									click: (e) => {
										this.logisticsInfos.push({
											companyName: '',
											code: '',
											receiver: '',
											freight: 0,
											note: '',
											creator: parseInt(localStorage.getItem(
												"userId")),
										});
									}
								}
							}));
							btnArr.push(h('Icon', {
								style: {
									cursor: 'pointer',
								},
								props: {
									type: 'ios-remove-circle-outline',
									size: 24
								},
								on: {
									click: (e) => {
										if (this.logisticsInfos.length > 1) {
											this.logisticsInfos.splice(params.index, 1);
										}
									}
								}
							}));

							return btnArr;
						}
					}
				]
			}
		},
		methods: {
			initCompanyTypeOptionList() {
				let self = this;
				//获取收付款账户数据字典
				return request.get('/api/DataDictionary/GetDataDictionaryList', {
					params: {
						code: this.companyNamePid
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取收付款账户数据失败：" + response.errorMsg
						});
						return;
					}
					self.companyTypeList = response.data;
					return self.companyTypeList[0].key;
				}).catch(function(error) {})
				return "";
			},
			addType() {
				if (!this.dictionaryFormItem.key) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '显示名不可为空!'
					});
					return;
				}
				this.dictionaryFormItem.value = this.dictionaryFormItem.key;
				this.dictionaryFormItem.pcode = this.companyNamePid;
				let self = this;
				request.post('/api/DataDictionary/AddDataDictionary', this.dictionaryFormItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}
					self.initCompanyTypeOptionList();
					self.dictionaryFormItem.key = '';
					self.dictionaryFormItem.value = '';
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '保存成功!'
					});
				}).catch(function(error) {})
			},
			deleType(id, pid) {
				var self = this;
				request.post('/api/DataDictionary/DeleDataDictionary', [id]).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.initCompanyTypeOptionList();
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '删除成功!'
					});
				}).catch(function(error) {})
			},
		},
		watch: {
			selectedLogistics: {
				deep: true,
				handler(arr) {
					if (arr.length > 0) {
						this.logisticsInfos = arr;
					}
				}
			}
		},
		created: function() {
			this.initCompanyTypeOptionList();
			this.$nextTick(() => {
				// 所有子组件以及当前组件自身都已渲染完毕
				this.logisticsInfos = this.selectedLogistics;
			})
		},
		mounted() {}
	}
</script>

<style scoped>
	.modal-title {
		overflow: hidden;
		padding-bottom: 10px;
		font-size: 16px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	/deep/ .ivu-table-cell {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.icon-item-dele {
		cursor: pointer;
	}

	.icon-item-dele:hover {
		transform: scale(1.3);
	}
</style>